/**
 * Public graphics contract between the 3D engine and whatever pushes the
 * user's settings into it (settings UI, `SettingsAndPresetsService`, desktop
 * store). The engine owns the meaning of each value; the caller only ever
 * reads/writes through `Engine.applyGraphicsOptions()` / `Engine.graphicsOptions`.
 */

/** Named lighting rigs the engine can switch between. See Engine.applyLightingStyle. */
export type LightingStyle = 'studio' | 'soft' | 'flat';

export interface EngineGraphicsOptions {
  lighting: LightingStyle;
}

export const DEFAULT_ENGINE_GRAPHICS: EngineGraphicsOptions = {
  lighting: 'studio'
};
